import { useState } from "react";

import { Campo } from "./Campo";
import type { PropsDoCampo } from "./Campo";
import { mascararTelefone, telefoneCompleto } from "../../nucleo/validacao";

const AVISO_DE_INCOMPLETO = "Telefone incompleto: informe o DDD e o número.";

export interface PropsDoCampoDeTelefone
  extends Omit<PropsDoCampo, "value" | "onChange" | "type" | "inputMode"> {
  valor: string;
  /** Recebe o texto já mascarado, ex.: `(47) 98456-6360`. */
  aoMudar: (valor: string) => void;
}

/** Campo de telefone brasileiro com máscara. Valor gravado antes da máscara também aparece
 *  formatado, porque a máscara é aplicada na exibição, não só na digitação. */
export function CampoDeTelefone({
  valor,
  aoMudar,
  placeholder,
  erro,
  onBlur,
  ...resto
}: PropsDoCampoDeTelefone) {
  // O aviso de incompleto só aparece depois que a pessoa sai do campo: no meio da digitação
  // todo número está incompleto. O erro de quem usa o campo sempre vence.
  const [saiu, setSaiu] = useState(false);
  const incompleto = saiu && valor.trim() !== "" && !telefoneCompleto(valor);
  return (
    <Campo
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      placeholder={placeholder ?? "(00) 00000-0000"}
      {...resto}
      erro={erro ?? (incompleto ? AVISO_DE_INCOMPLETO : undefined)}
      onBlur={(evento) => {
        setSaiu(true);
        onBlur?.(evento);
      }}
      value={mascararTelefone(valor)}
      onChange={(evento) => aoMudar(mascararTelefone(evento.target.value))}
    />
  );
}
